type DigitalData = {
  page_data?: {
    page_path?: string;
  };
};

export const sendDecibelData = ({
  digitalData = { page_data: {} }
}: {
  digitalData?: DigitalData;
}) => {
  window.decibelInsight &&
    window.decibelInsight('trackPageView', digitalData.page_data?.page_path);
};
